import { defineStore } from "pinia";
import type { User } from "firebase/auth";

export const useUserStore = defineStore("user", {
  state: () => ({
    user: null as User | null,
  }),

  getters: {
    isLoggedIn: (state) => state.user !== null,
    uid: (state) => state.user?.uid ?? null,
    email: (state) => state.user?.email ?? null,
  },

  actions: {
    setUser(user: User | null) {
      console.log("setUser", user);
      this.user = user;
    },
    async signOut() {
      const { $firebase } = useNuxtApp();
      ($firebase as any)?.auth.signOut();
      this.user = null;
    },
  },
});
